import "../../datagrid.scss";
import { useContext, useEffect, useState, useRef, useMemo } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { VisitasContext } from '../../../context/visitas/VisitasContext';
import { Paginator } from '../../../components/paginator/Paginator';
import { headers, headersImpresion } from "./configGrid/headers";
import { formatRows, formatRowsImpresion } from "./configGrid/rows";
import { indice } from "../../../components/DataGrid/indice";
import { getActionColumn } from "../../../components/ActionesColumns/ActionColumns";
import CircularProgress from "@mui/material/CircularProgress";
import useDocumentTitle from "../../../components/Title";
import CustomDataGrid from "../../../components/DataGrid/CustomDataGrid";
import SearchButton from "../../../components/SearchButton/SearchButton";
import ConfirmDialog from "../../../components/dialogs/DeleteDialog";
import ErrorDialog from "../../../components/dialogs/ErrorDeleteDialog";
import { fetchEntityData, fetchEntityPrintData, deleteItem } from './configGrid/apiCalls';
import FiltersGrid from './filtersGrid/filtersGrid';
import { useFilters } from "../../../context/FiltersContext";
import dayjs from 'dayjs';
import ModalInformes from '../../../components/Imprimir/ModalImpresion';
import { FaFileDownload } from 'react-icons/fa';
import { AuthContext } from '../../../context/AuthContext';

export const Datatable = (tipoprecio, tipovista = "conStock") => {
  const { empresaData } = useContext(AuthContext);
  const titleGrid = "Lista de Visitas"
  useDocumentTitle(titleGrid);
  const { updateFilters, getFilters } = useFilters();
  const contexto = useContext(VisitasContext);
  const { deleteVisitaData, getVisitasPanelData } = contexto;
  const navigate = useNavigate();

  const nameData = "visitas";
  const getData = getVisitasPanelData;
  const deleteData = deleteVisitaData;

  // Estado para Datos y Paginacion
  const [listaItems, setListaItems] = useState([]);
  const [totalItems, setTotalItems] = useState(0);
  // Estado para Loading
  const [isLoading, setIsLoading] = useState(false);
  // Estados para la paginación
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [numPagina, setNumPagina] = useState(1);
  const [filas, setFilas] = useState(isMobile ? 20 : 100);
  // Estado del buscador
  const [searchIDCli, setSearchIDCli] = useState();
  const [searchDescCli, setSearchDescCli] = useState();
  const [searchIDEmp, setSearchIDEmp] = useState();
  const [searchDescEmp, setSearchDescEmp] = useState();
  const [dateFrom, setDateFrom] = useState("");
  const [dateUntil, setDateUntil] = useState("");
  const [hourFrom, setHourFrom] = useState("");
  const [hourUntil, setHourUntil] = useState("");
  const [tienePedido, setTienePedido] = useState();
  // Ref para busqueda
  const searchInputRef = useRef(null);
  const isFetchingRef = useRef(false);
  // Estado para el modal de confirmación
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  // Estado para manejar el error
  const [errorMessage, setErrorMessage] = useState("");
  const [isErrorDialogOpen, setIsErrorDialogOpen] = useState(false);
  //Modal Para informes
  const [openModalInformes, setOpenModalInformes] = useState(null);
  const [dataImpresion, setDataImpresion] = useState(null);
  //Estado General de Filtros en LocalStorage
  const [isInitialized, setIsInitialized] = useState(false);
  const pageKey = "visitas";


  // 🔹 Obtenemos los filtros persistidos
  const filters = getFilters(pageKey) || {
    searchIDCli: "",
    searchDescCli: "",
    searchIDEmp: "",
    searchDescEmp: "",
    dateFrom: "",
    dateUntil: "",
    hourFrom: "",
    hourUntil: "",
    tienePedido: ""
  };

  useEffect(() => {
    const savedFilters = getFilters(pageKey);

    if (savedFilters) {
      setSearchIDCli(savedFilters.searchIDCli || "");
      setSearchDescCli(savedFilters?.searchDescCli || "");
      setSearchIDEmp(savedFilters.searchIDEmp || "");
      setSearchDescEmp(savedFilters?.searchDescEmp || "");
      setDateFrom(savedFilters.dateFrom || "");
      setDateUntil(savedFilters.dateUntil || "");
      setHourFrom(savedFilters.hourFrom || "");
      setHourUntil(savedFilters.hourUntil || "");
      setTienePedido(savedFilters.tienePedido || "");
      setNumPagina(1);
    }

    setIsInitialized(true);
  }, []);

  useEffect(() => {
    if (!isInitialized) return;

    fetchData();
    fetchDataImpresion();
    loadFilters();
  }, [isInitialized, searchIDCli, searchIDEmp, dateFrom, dateUntil, hourFrom, hourUntil, tienePedido, numPagina, filas]);


  // 🔹 Función segura para actualizar filtros
  const loadFilters = () => {
    const updatedFilters = {
      searchIDCli,
      searchDescCli,
      searchIDEmp,
      searchDescEmp,
      dateFrom,
      dateUntil,
      hourFrom,
      hourUntil,
      tienePedido
    };

    updateFilters(pageKey, updatedFilters);
  };

  // Dentro del componente `Datatable`
  const formatDate = (date) =>
    date ? dayjs(date).format('YYYY-MM-DD') : "";

  const formatHour = (hour) =>
    hour ? dayjs(hour).format('HH:mm') : "";

  const fetchData = async () => {
    if (isFetchingRef.current) return;
    isFetchingRef.current = true;
    setIsLoading(true);

    try {
      const { dataEntity, totalItems, totalPage } = await fetchEntityData(
        getData,
        searchIDCli || "",
        searchIDEmp || "",
        formatDate(dateFrom),
        formatDate(dateUntil),
        formatHour(hourFrom),
        formatHour(hourUntil),
        tienePedido,
        numPagina,
        filas
      );

      if (numPagina > totalPage) {
        setNumPagina(totalPage);
      } else {
        setListaItems(dataEntity);
        setTotalItems(totalItems);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
      isFetchingRef.current = false;
    }
  };

  const fetchDataImpresion = async () => {
    try {

      const { dataEntity } = await fetchEntityPrintData(
        getData,
        searchIDCli || "",
        searchIDEmp || "",
        formatDate(dateFrom),
        formatDate(dateUntil),
        formatHour(hourFrom),
        formatHour(hourUntil),
        tienePedido
      );
      setDataImpresion(dataEntity)
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
      isFetchingRef.current = false;
    }
  };

  const handleDelete = async () => {
    try {
      await deleteItem(deleteData, selectedItem);
      fetchData(); // Refresca los datos
      closeModal(); // Cierra el modal de confirmación
    } catch (error) {
      console.error(error);
      setErrorMessage("No se pudo eliminar el elemento. Inténtalo nuevamente.");
      setIsErrorDialogOpen(true);
    }
  };

  const closeErrorDialog = () => {
    setErrorMessage(""); // Limpia el mensaje de error
    setIsErrorDialogOpen(false); // Cierra el diálogo de error
  };

  const openModal = (id) => {
    setSelectedItem(id);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setSelectedItem(null);
    setIsModalOpen(false);
  };

  const handleClickEdit = (e) => {
    if (e) navigate(`/${nameData}/new/${e}`);
  };

  // Dentro de la función Datatable...
  const datosColum = useMemo(() => {
    const commonCols = indice(numPagina, filas).concat(headers.filter((column) => !column.hidden));
    return commonCols.concat(getActionColumn(handleClickEdit, openModal));
  }, [numPagina, filas]);

  const rows = useMemo(() => formatRows(listaItems), [listaItems]);

  const headersData = useMemo(() => {
    return headersImpresion.filter(header => {
      if (header.field === "cli_name" && searchDescCli) {
        return false; // Oculta la columna
      }
      if (header.field === "sel_name" && searchDescEmp) {
        return false; // Oculta la columna
      }
      if (header.field === "estado_pedido" && tienePedido) {
        return false; // Oculta la columna
      }
      return true; // Mantiene el resto
    });
  }, [headersImpresion, searchDescCli, searchDescEmp, tienePedido]);

  const filtersImpresion = useMemo(() => {
    return [
      { descripcion: 'Cliente', valor: searchDescCli },
      { descripcion: 'Preventista', valor: searchDescEmp },
      { descripcion: 'Fecha Desde', valor: formatDate(dateFrom) },
      { descripcion: 'Hora Desde', valor: formatHour(hourFrom) },
      { descripcion: 'Fecha Hasta', valor: formatDate(dateUntil) },
      { descripcion: 'Hora Hasta', valor: formatHour(hourUntil) },
      {
        descripcion: 'Tiene pedido',
        valor: Number(tienePedido) === 0 ? "SI"
          : Number(tienePedido) === 1 ? "NO"
            : null
      }


    ].filter(f =>
      f.valor !== null &&
      f.valor !== undefined &&
      f.valor !== '' &&
      typeof f.valor !== 'object'
    );
  }, [searchDescCli, searchDescEmp, dateFrom, hourFrom, dateUntil, hourUntil, tienePedido]);

  const rowsData = useMemo(() => {
    if (!dataImpresion) return [];
    return formatRowsImpresion(dataImpresion, tipovista);
  }, [dataImpresion, tipovista]);

  const informesConfig = [
    {
      headers: headersData,
      rows: rowsData,
      filters: filtersImpresion,
      title: "Informe de Visitas",
      tipo: "both",
    },
  ];

  return (
    <div className="datatable">
      <div className="datatableTitle">
        <h3>{titleGrid}</h3>
        <button
          onClick={() => setOpenModalInformes(true)}
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '6px',
            backgroundColor: '#2563eb', // azul
            color: 'white',
            padding: '6px 12px',
            border: 'none',
            borderRadius: '6px',
            cursor: 'pointer',
          }}
        >
          <FaFileDownload size={18} />
          <span>Informes</span>
        </button>

        <ModalInformes
          open={openModalInformes}
          onClose={() => setOpenModalInformes(false)}
          informes={informesConfig}
          empresa={empresaData}
        />
        <div className="filterContainer">
          <FiltersGrid
            setSearchIDFilter={setSearchIDCli}
            setSearchDescFilter={setSearchDescCli}
            searchDescFilter={searchDescCli}
            setSearchSecondIDFilter={setSearchIDEmp}
            setSearchSecondDescFilter={setSearchDescEmp}
            searchSecondDescFilter={searchDescEmp}
            dateFromFilter={dateFrom}
            dateUntilFilter={dateUntil}
            setDateFromFilter={setDateFrom}
            setDateUntilFilter={setDateUntil}
            hourFromFilter={hourFrom}
            hourUntilFilter={hourUntil}
            setHourFromFilter={setHourFrom}
            setHourUntilFilter={setHourUntil}
            searchPedidoFilter={tienePedido}
            setSearchPedidoFilter={setTienePedido}
          />
          <div className="linkContainer">

          </div>
        </div>
      </div>

      {(isLoading) ? (
        <div className="loading">
          <div style={{ display: "flex", justifyContent: "center", margin: "20px" }}>
            <h1>Cargando datos...</h1>
            <CircularProgress />
          </div>
        </div>
      ) : (
        <>
          <div className="datagridWrapper">

            <CustomDataGrid
              rows={rows}
              columns={datosColum}
              pageSize={filas}
              rowCount={totalItems}
              onPageChange={setNumPagina}
              onPageSizeChange={(newPageSize) => {
                setFilas(newPageSize);
                setNumPagina(1);
              }}
              isLoading={isLoading}
              onRowClick={() => { }}
              enableSelectionClick={false}
            />
          </div>
          <div className="paginatorWrapper">
            <Paginator
              numPagina={numPagina}
              setNumPagina={setNumPagina}
              totalPages={Math.ceil(totalItems / filas)}
              filas={filas}
              setFilas={setFilas}
              totalDataItems={totalItems}
            />
          </div>
          <ConfirmDialog
            open={isModalOpen}
            onClose={closeModal}
            onConfirm={handleDelete}
            nameData={nameData}
          />

          <ErrorDialog
            open={isErrorDialogOpen}
            onClose={closeErrorDialog}
            errormessages={errorMessage}
          />
        </>

      )}
    </div>
  );
};

export default Datatable;
